// REACT
import React from "react";
import { Container, Table, TableCell, TableHead, TableRow } from "@mui/material";
import TableSort from "src/components/common/TableSort";
import TableBody from "./TableBody";

// ASSETS
import { HoldingsListStyles } from "../common/styles/HoldingsList.styles";
import { Holdings } from "../common/types/holdings";

// TYPES
import { HeadCell, Order } from "src/components/common/tableTypes";
import { HoldingRes } from "src/store/features/api/generated";

const headCells: HeadCell[] = [
  {
    id: "code",
    label: "Coin",
  },
  {
    id: "name",
    label: "Name",
  },
  {
    id: "totalUnits",
    label: "Total Units",
  },
  {
    id: "available",
    label: "Available Units",
  },
  {
    id: "price",
    label: "Price",
  },
  {
    id: "value",
    label: "Available",
  },
  {
    id: "total",
    label: "Total",
  },
  {
    id: "change",
    label: "Change (24h)",
  },
];

interface HoldingsTableProps {
  holdings: HoldingRes[] | undefined;
}

const HoldingsTable = React.memo((props: HoldingsTableProps): JSX.Element => {
  const { holdings } = props;
  const classes = HoldingsListStyles();

  // flatten shallow nested object
  const flatten = (ob: any) => {
    let result: any = {};

    for (const i in ob) {
      // check if change is null to then handle value correctly in table body
      if (i === "change" && ob["change"] === null) {
        result["change"] = null;
      }
      if (typeof ob[i] === "object" && !Array.isArray(ob[i])) {
        const temp = flatten(ob[i]);
        for (const j in temp) {
          result[j] = temp[j];
        }
      } else {
        result[i] = ob[i];
      }
    }
    return result;
  };

  // SORT TABLE BODY DATA BY TOKEN WITH MOST MARKET VALUE
  const sorted = React.useMemo((): Holdings[] => {
    if (!holdings) return [];
    const flattenHoldings: Holdings[] = [];
    for (let i = 0; i < holdings.length; i++) {
      flattenHoldings.push(flatten(holdings[i]));
    }
    return flattenHoldings;
  }, [holdings]);

  // Table Sort Logic
  const [order, setOrder] = React.useState<Order>("desc");
  const [orderBy, setOrderBy] = React.useState<string>("total");
  const handleRequestSort = React.useCallback(
    (property: string) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    },
    [order, orderBy],
  );
  return (
    <>
      <Container className={classes.tableContainer}>
        <Table>
          <TableHead>
            <TableRow
              style={{
                borderBottom: "3px solid #313F4F",
              }}>
              {headCells.map(
                (head: HeadCell): JSX.Element => (
                  <TableCell key={head.id} className={classes.tableHeadItem}>
                    <TableSort
                      order={order}
                      orderBy={orderBy}
                      onClick={handleRequestSort}
                      headCell={head}
                    />
                  </TableCell>
                ),
              )}
            </TableRow>
          </TableHead>
          <TableBody data={sorted} order={order} orderBy={orderBy} />
        </Table>
      </Container>
    </>
  );
});

export default HoldingsTable;
